import { NvIconModule } from './../../../../../nvps-libraries/design/nv-icon/nv-icon.module';
import { CommonModule } from '@angular/common';
import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { ContactCardComponent } from './contact-card.component';
import { MatRippleModule } from '@angular/material/core';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ContactCardComponent],
  imports: [NvTooltipModule, MatRippleModule, CommonModule, NvIconModule],
  exports: [ContactCardComponent],
  providers: [],
})
export class ContactCardModule {}
